<template>
  <prism-editor class="my-editor height" v-model="code" :highlight="highlighter" :readonly="readonly" line-numbers>
  </prism-editor>
</template>

<script>
import { PrismEditor } from "vue-prism-editor";
import "vue-prism-editor/dist/prismeditor.min.css";

import { highlight, languages } from "prismjs/components/prism-core";
import "prismjs/components/prism-clike";
import "prismjs/components/prism-javascript";
import "prismjs/components/prism-pascal";
import "prismjs/components/prism-json";
import "prismjs/themes/prism-tomorrow.css";

export default {
  name: "Highlighter",
  props: {
    modelValue: String,
    langName: {
      type: String,
      default: "js",
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:modelValue"],
  methods: {
    highlighter(code) {
      return highlight(code, languages[this.langName]);
    },
  },
  computed: {
    code: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit("update:modelValue", val);
      },
    },
  },
  components: { PrismEditor },
};
</script>

<style lang="scss" scoped>
.my-editor {
  font-family: Fira code, Fira Mono, Consolas, Menlo, Courier, monospace;
  font-size: 1.1rem;
  line-height: 1.5;
  padding: 5px;

  &.height {
    height: 600px;
  }
}

.my-editor::selection {
  background: #333333;
  //color: #ffffff;
}

::v-deep(.prism-editor__textarea:focus) {
  outline: none !important;
}

.prism-editor-wrapper {
  border: 1px solid !important;
  border-radius: 4px;
}
</style>
